module.exports = __webpack_public_path__ + "assets/7657708c06b2992742bd8c71fc8c943b.mp3";